import { formatPercentage } from 'components/featured/Deals/components/DealDetailsMain/Details/utils';
import { formatDealAmount } from 'helper/short-currency';

export const metrics: Record<MetricType, number> = {
  successRate: 75,
  avgVelocity: 32,
  avgDealSize: 675000,
  lifetimeValue: 3400000,
};

export type MetricType = 'successRate' | 'avgVelocity' | 'avgDealSize' | 'lifetimeValue';

export const formatMetrics = (key: MetricType, value: number) => {
  if (key === 'avgVelocity') return value ? value + 'd' : '0d';
  if (key === 'successRate') return formatPercentage(value);
  return formatDealAmount(value);
};
